import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CaseFormsService} from '../case-forms.service';
import {FormConfigurationModel} from '../../../models/forms/form-configuration.model';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {DataPatientCaseWorkItemModel} from '../../../models/accountsReceivable/data-patient-case-work-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {DataPatientCaseWorkItemToothModel} from '../../../models/teeth/data-patient-case-work-item-tooth.model';
import { firstValueFrom } from 'rxjs';
import { UiService } from 'src/app/services/ui.service';

@Component({
  standalone: false,
  selector: 'app-case-procedure-add-form',
  templateUrl: './case-procedure-add-form.component.html',
  styleUrls: ['./case-procedure-add-form.component.scss']
})
export class CaseProcedureAddFormComponent implements OnInit {
  searchPredicate: (data: any, filter: string) => boolean;
  caseProcedureName: string;
  caseWorkItemID: string;
  caseProcedureID: string;
  dFormsAll: FormConfigurationModel[] = [];
  dFormsProcedure: FormConfigurationModel[] = [];
  dFormIDsAdded: string[] = [];
  dFormsSelected: FormConfigurationModel[] = [];
  isLoading: boolean;
  caseWorkItem: DataPatientCaseWorkItemModel;
  isShowInReview: boolean = false;

  selectionSection: number = 0;
  selectedIndex: number = 0;
  formsTabRightLabel: string = 'All Forms';
  locid: number;

  selectedDataPatientCaseWorkItemTeeth: string[] = [];

  constructor(
    public readonly dialogRef: MatDialogRef<CaseProcedureAddFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly caseService: CaseFormsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly uiService: UiService,
    )
  {
    this.searchPredicate = (searchData: FormConfigurationModel, filter: string) => {
      if ((!searchData.DFormName ? '' : searchData.DFormName).toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    };
  }

  ngOnInit() {
    this.caseWorkItem = this.data.CaseWorkItem;
    this.selectionSection = this.data.SelectionSection;

    if (this.selectionSection === 0) {
      this.formsTabRightLabel = 'Available Forms';
      this.loadForGeneralForms();
    }
    else {
      this.loadForProcedure();
    }
  }

  async loadForProcedure() {

    this.caseWorkItemID = this.data.CaseWorkItemID;
    this.caseProcedureName = this.data.CaseProcedureName;
    this.isLoading = true;

    // get all enums
    const promises: any[] = [
      this.caseService.getProcedureDFormsByCaseWorkItem(this.caseWorkItemID).toPromise(),
      this.caseService.getDFormIDsByCaseWorkItem(this.caseWorkItemID).toPromise()
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.dFormsProcedure = results[0];
      this.dFormIDsAdded = results[1];
      // remove any forms (from the All Forms) that are tied to a caseworkitem in cfgCaseProcedureForm
      this.loadForms();
    } catch (err) {
      this.isLoading = false;
      this.showMessage('Something went wrong', 'Error');
    }

    if (this.caseWorkItem.dataPatientCaseItemTeeth.length === 1) {
      this.selectedDataPatientCaseWorkItemTeeth.push(this.caseWorkItem.dataPatientCaseItemTeeth[0].CaseWorkItemToothId);
    }
  }

  loadForms() {
    this.isLoading = true;
    this.caseService.getCfgDFormsAll(this.isShowInReview).subscribe((forms) => {
      this.dFormsAll = forms;

      this.dFormsProcedure.forEach(form => {
        this.dFormsAll = this.dFormsAll.filter(a => a.DFormId.toLowerCase() !== form.DFormId.toLowerCase());
      });

      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }

  async loadForGeneralForms() {

    this.caseWorkItemID = this.data.CaseWorkItemsPatientFormsCaseWorkItemID;
    //const addedGeneralPatientForms: PatientCaseWorkItemFormDataModel[] = this.data.AddedGeneralPatientForms;
    this.locid = this.data.LOCID;
    this.isLoading = true;

    // get all enums
    const promises: any[] = [
      this.isShowInReview
        ? firstValueFrom(this.caseService.getCfgDFormsAll(true, this.locid))
        : firstValueFrom(this.caseService.getCfgSchedulePatientFormsAll(this.locid)),
    ];

    try {
      const results: any[] = await Promise.all(promises);
      this.dFormsAll = results[0];

      // Removed filter to show all forms
      // remove any forms (from the All Forms) that are already added
      // addedGeneralPatientForms.forEach(form => {
      //   this.dFormsAll = this.dFormsAll.filter(a => a.DFormId.toLowerCase() !== form.DFormId.toLowerCase());
      // });

      this.isLoading = false;
      this.cdr.detectChanges();
    } catch (err) {
      this.isLoading = false;
      this.cdr.detectChanges();
      this.showMessage('Something went wrong', 'Error');
    }
  }

  showMessage(type, message) {
    this.uiService.displayMessage(type, message);
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  onRowSelected($event: TdoTableSelectionEvent) {
    // For single selection, always replace the selection with the current form
    if ($event.isSelected) {
      this.dFormsSelected = [$event.model];
    } else {
      this.dFormsSelected = [];
    }
  }

  addForms() {
    if(this.dFormsSelected.find(x => x.isToothRequired === true) && this.selectedDataPatientCaseWorkItemTeeth.length < 1
      && this.selectionSection === 1)
      {
          this.showMessage('Warning', 'Please select tooth / teeth:');
          return;
      }
    this.isLoading = true;
    this.caseService.addFormsToCaseWorkItem(this.caseWorkItemID, this.dFormsSelected, this.selectedDataPatientCaseWorkItemTeeth)
      .subscribe((response: any) => {
        this.isLoading = false;
        this.dialogRef.close(response);
        this.showMessage('Success', 'Form(s) added');
      }, err => {
        this.isLoading = false;
        this.showMessage('Error', 'Problem adding forms');
        console.error("Error adding forms: ", err);
        this.cdr.detectChanges();
      });
  }

  onSelectedTeethChange(event: MatCheckboxChange, caseWorkItemTooth: DataPatientCaseWorkItemToothModel) {
    if (event.checked) {
      if (!this.selectedDataPatientCaseWorkItemTeeth.includes(caseWorkItemTooth.CaseWorkItemToothId)) {
        this.selectedDataPatientCaseWorkItemTeeth.push(caseWorkItemTooth.CaseWorkItemToothId);
      }
    } else {
      const idx = this.selectedDataPatientCaseWorkItemTeeth.findIndex(p => p === caseWorkItemTooth.CaseWorkItemToothId);
      if (idx > -1) {
        this.selectedDataPatientCaseWorkItemTeeth.splice(idx, 1);
      }
    }
  }


  onIsShowInReviewChange(event: MatCheckboxChange) {
    this.isShowInReview = event.checked;
    this.dFormsSelected = [];
    if (this.selectionSection === 0) {
      this.loadForGeneralForms();
    } else {
      this.loadForms();
    }
  }

  onSelectedIndexChange(event: number) {
    this.selectedIndex = event;
  }

  isChecked(cb: DataPatientCaseWorkItemToothModel) {
    return this.selectedDataPatientCaseWorkItemTeeth.includes(cb.CaseWorkItemToothId);
  }
}
